import type { SVGProps } from 'react'
const SvgSyTechSolidDataChat = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path d="M16.791 6.375a.84.84 0 0 1 .834.846V17.64a.685.685 0 0 1-.75.735H4.688L2.25 20.812V7.221a.84.84 0 0 1 .834-.846z" />
		<path
			fillOpacity={0.24}
			d="M12.375 11.438h2.813v4.875h-2.813zm-3.75-2.813h2.813v7.688H8.625zm-3.75 1.5h2.813v6.188H4.875z"
		/>
		<path
			fill="#e9e9e9"
			d="M20.916 3.188a.84.84 0 0 1 .833.8v13.637l-2.25-2.25h-.75v-9.3a.823.823 0 0 0-.824-.821H6.375V4.033a.84.84 0 0 1 .8-.845z"
		/>
	</svg>
)
export default SvgSyTechSolidDataChat
